import { render, staticRenderFns } from "./actionsItem.vue?vue&type=template&id=c93f44fe&scoped=true"
import script from "./actionsItem.vue?vue&type=script&lang=js"
export * from "./actionsItem.vue?vue&type=script&lang=js"
import style0 from "./actionsItem.vue?vue&type=style&index=0&id=c93f44fe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93f44fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zhenzhaopin\\xxh-zhaopin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c93f44fe')) {
      api.createRecord('c93f44fe', component.options)
    } else {
      api.reload('c93f44fe', component.options)
    }
    module.hot.accept("./actionsItem.vue?vue&type=template&id=c93f44fe&scoped=true", function () {
      api.rerender('c93f44fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aiChat/components/question/actionsItem.vue"
export default component.exports